import { render, staticRenderFns } from "./OtherSourceOfFundsSection.vue?vue&type=template&id=6d4bd7c0"
import script from "./OtherSourceOfFundsSection.vue?vue&type=script&lang=js"
export * from "./OtherSourceOfFundsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports